import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapGroupBy'
})
export class MapGroupByPipe implements PipeTransform {
  transform(items: any[], property: string): { [key: string]: any[] } {
   

    const groupedItems: { [key: string]: any[] } = {};
    items.forEach(item => {
      const key = item[property];
      if (!groupedItems[key]) {
        groupedItems[key] = [];
      }
      groupedItems[key].push(item);
    });
    return groupedItems;
  }
}